module.exports = __webpack_public_path__ + "static/img/shushi-2.f9998c89.png";